import { Routes, Route, Navigate, useParams } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import TournamentView from "./TournamentView.js";

const View = () => {
  const { category } = useParams();

  const [gender, distanceStr] = category.split("-distance");
  const distance = distanceStr;

  return <TournamentView gender={gender} distance={distance} />;
};

const Tournament = () => {
  const tabs = [
    { path: "m-distance145", label: "M_145M(Kungdo)" },
    { path: "m-distance90", label: "M_90M(TarscaShild)" },
    { path: "m-distance70", label: "M_70M(Puta)" },
    { path: "m-distance30", label: "M_30M(Zamby)" },
    { path: "f-distance145", label: "F_145M(Kungdo)" },
    { path: "f-distance90", label: "F_90M(TarscaShild)" },
    { path: "f-distance70", label: "F_70M(Puta)" },
    { path: "f-distance30", label: "F_30M(Zamby)" },
  ];

  return (
    <>
      <Navigation
        tabs={tabs}
        basePath="/match-results/tournament"
        variant="tab"
      />

      <Routes>
        <Route path="/" element={<Navigate to="m-distance145" replace />} />
        <Route path=":category/" element={<View />} />
      </Routes>
    </>
  );
};
export default Tournament;
